<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent(); scrollContentToTop()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<app-loading-circle *ngIf="loading"> </app-loading-circle>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    #content
    class="content-list"
    [ngClass]="{ 'content-list--with-button': selectedItem }"
  >
    <app-ion-common-label
      class="document-type-label1"
      labelStyle="display-rg"
      labelDescription="E cidade que você nasceu?"
    >
    </app-ion-common-label>

    <div class="conent-center conent-center--mrt-lg">
      <div class="my-search">
        <app-ion-common-search
          [textSearch]="textSearch"
          [ariaLabel]="'Busque por cidades'"
          [placeholder]="'Busque por cidades'"
          [list]="birthCity"
          [fieldSearch]="fieldSearch"
          [textError]="'Cidade não encontrada'"
          (sendTextSearch)="textSearch = $event"
        >
        </app-ion-common-search>
      </div>

      <app-ion-common-radio
        class="document-type-options"
        [itens]="birthCity"
        [selectedValue]="selectedItem"
        [textSearch]="textSearch"
        [fieldSearch]="fieldSearch"
        (changeRadio)="selectedItem = $event; changeValue()"
        (valueNameRadio)="selectedName = $event"
        [disabled]="!this.edit"
      ></app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    class="hidden"
    [ngClass]="{ hidden: selectedItem?.length === 0 }"
    [attr.aria-hidden]="selectedItem?.length === 0"
    (clickButton)="clickNext()"
    label="Continuar"
  >
  </app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="getDomainCity()"
  >
  </app-ion-common-retry>
</ion-content>
